export default __webpack_public_path__ + "static/media/iphone-flight-6.5.884cd8f2.jpg";